var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeaderActionButton',{attrs:{"on-pressed":_vm.onPressed},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('v-icon',[_vm._v("mdi-cog-outline")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }